import styled from "@emotion/styled";
import { Box, Button } from "@mui/material";
import { keyframes } from "@emotion/react";

const glowAnimation = keyframes`
    0%, 100% { box-shadow: 0 0 20px 5px rgba(29, 112, 210, 0.3); }
    50%       { box-shadow: 0 0 35px 10px rgba(168, 85, 247, 0.4); }
`

export const PageContainer = styled(Box)`
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    padding: 2rem 3rem;

    @media (max-width: 600px) {
        padding: 1.5rem 1rem;
    }
`

export const FormWrapper = styled(Box)`
    max-width: 720px;
    width: 100%;
    margin: 2rem auto 0;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
`

export const PlanoBannerOuter = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
`

export const PopularBadge = styled(Box)`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(to right, #1d70d2, #9333ea);
    color: white;
    font-size: 0.625rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    padding: 0.375rem 0.75rem;
    border-radius: 9999px;
    white-space: nowrap;
    position: relative;
    z-index: 2;
    margin-bottom: -14px;
`

export const PlanoBannerWrapper = styled(Box)`
    width: 100%;
    border-radius: 2rem;
    padding: 2px;
    background: linear-gradient(to right, #1d70d2, #a855f7);
    box-shadow: 0 25px 50px -12px rgba(29, 112, 210, 0.25);
    transition: transform 0.3s ease;

    &:hover {
        transform: scale(1.01);
    }
`

export const PlanoBannerInner = styled(Box)`
    border-radius: calc(2rem - 2px);
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(12px);
    padding: 1.5rem;
    padding-top: 2rem;
    display: flex;
    align-items: center;
    gap: 1rem;
`

export const BotaoFreeTrial = styled(Button)`
    background-color: #1d70d2;
    color: white;
    border: none;
    border-radius: 1rem;
    height: 3.5rem;
    font-weight: 700;
    padding: 0 2rem;
    animation: ${glowAnimation} 3s ease-in-out infinite;

    &:hover {
        background-color: #1558a8;
    }
`

export const ActionsContainer = styled(Box)`
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 1rem;

    @media (max-width: 600px) {
        flex-direction: column-reverse;
        button {
            width: 100%;
        }
    }
`
